/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_ViewInputs */

const vi_shop_home_view = /** @type {(inputs: Shop_Home_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

/**

* @param {Shop_Home_ViewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_view = /** @type {((inputs?: Shop_Home_ViewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_ViewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_view(inputs)
});